/* 무료보험 프로모션 추가부분 */
import React, { useEffect, useState } from 'react'
import className from 'classnames/bind'
import { useHistory } from 'react-router-dom'

import style from './MyhouseInsuranceDetail.module.scss'

import InsurancePromotionTooltip from '@Components/atoms/InsurancePromotionTooltip'
import IconInsuranceArrow from '@Ui/images/myhouse/IconInsuranceArrow.svg'
import MyhouseInsuranceLogo from '@Ui/images/myhouse/MyhouseInsuranceLogo.svg'
import InsuranceLayout from '@Components/atoms/InsuranceLayout'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'

const cx = className.bind(style)

const MyhouseInsuranceDetail = () => {
  const history = useHistory()

  const handleBackClick = (e: React.MouseEvent) => {
    e.preventDefault()
    if (history.length > 1) {
      history.goBack()
    } else {
      window.close()
      // 닫기 실패시 메인으로 강제 이동
      window.location.href = LAND_SERVICE_PREFIX_URL.MYHOUSE
    }
  }
  const [isScrollTop, setIsScrollTop] = useState(window.scrollY <= 5)

  const scrollListener = () => {
    setIsScrollTop(window.scrollY <= 5)
  }

  useEffect(() => {
    window.addEventListener('scroll', scrollListener)
    return () => {
      window.removeEventListener('scroll', scrollListener)
    }
  }, [])

  return (
    <div className={cx('article')}>
      <header className={cx('header', !isScrollTop && 'type_fixed')}>
        <div className={cx('inner')}>
          <a href="#" onClick={handleBackClick} className={cx('link_back')}>
            <IconInsuranceArrow />
            <span className="blind">이전 페이지</span>
          </a>
          <h1 className={cx('title')}>우리집 화재보험 상세 안내</h1>
        </div>
      </header>
      <InsuranceLayout>
        <div className={cx('wrap')}>
          <div className={cx('introduce')}>
            <span className={cx('image')}>
              <MyhouseInsuranceLogo />
            </span>
            <div className={cx('sub_area')}>
              <h2 className={cx('label')}>
                DB손해보험
                <div className={cx('sub_title')}>프로미가정종합보험</div>
              </h2>
            </div>
          </div>
          <div className={cx('info')}>
            <div className={cx('item')}>
              <h3 className={cx('info_title')}>보상 내용</h3>
              <p className={cx('text')}>
                우연하고 직접적이며 물리적으로 생긴 손해(화재포함)로 인해 보험가입증서에 기재된 주택 내의 가재도구에 피해를 입으면 가재도구 시가를 기준으로 계산한 손해액을 가재의
                보험가입금액(최대 3,000만원)내에서 보상합니다.
              </p>
              <div className={cx('help')}>
                가재도구란?
                <InsurancePromotionTooltip
                  title="가재도구란?"
                  message="보험가입증서에 기재된 주택 내에 있는 것을 말하며, 피보험자 또는 동거하는 친족(민법 제 777조의 규정에 의한 친족의 범위와 같습니다. 이하같습니다.)의 소유물. 붙박이 가전제품(Built-In가전)은 가재에 포함."
                  style={{ padding: '3px' }}
                />
              </div>
            </div>
            <div className={cx('item')}>
              <h3 className={cx('info_title')}>보장 기간</h3>
              <p className={cx('text')}>집주인 인증 성공 후 익월 00시부터 1년 간 보장됩니다.</p>
            </div>
            <div className={cx('item')}>
              <h3 className={cx('info_title')}>보험금 청구 방법</h3>
              <p className={cx('text')}>
                사고에 해당되면 유선으로 보상 안내를 받을 수 있어요. DB손해보험 고객센터 :{' '}
                <a href="tel:1588-0100" className={cx('link_call')}>
                  1588-0100
                </a>
              </p>
            </div>
            <div className={cx('item')}>
              <h3 className={cx('info_title')}>보험금 청구시 필요 제출 서류</h3>
              <ul className={cx('list')}>
                <li className={cx('document')}>화재증명원</li>
                <li className={cx('document')}>개인(신용)정보처리동의서</li>
                <li className={cx('document')}>가재도구명세서(구입연월일 기재)</li>
                <li className={cx('document')}>신품가격견적서(구입처)</li>
                <li className={cx('document')}>수리비견적서, 영수증</li>
              </ul>
            </div>
          </div>
        </div>
      </InsuranceLayout>
    </div>
  )
}

export default MyhouseInsuranceDetail
